<template>
  <v-navigation-drawer app fixed clipped>
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title class="text-h6">
          Sport Types
        </v-list-item-title>
        <v-list-item-subtitle>
          Select sport to drill down
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

    <v-divider></v-divider>

    <v-list
      dense
      nav
    >
      <v-list-group
        v-for="sport in getSportTypes"
        :key="sport.id"
        no-action
        @click="getCategories(sport.id)"
      >
        <template v-slot:activator>
          <v-list-item-content>
            <v-list-item-title>{{ sport.name }}</v-list-item-title>
          </v-list-item-content>
        </template>

        <v-progress-circular
          :size="15"
          :width="2"
          indeterminate
          color="#fe3d89"
          v-if="typeof getSportCategories[sport.id] === 'undefined'"
          class="loadingCategory"
        ></v-progress-circular>

        <v-list v-else>
          <v-list-group
            v-for="category in getSportCategories[sport.id]"
            :key="category.id"
            no-action
            class="category"
          >
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>{{ category.name }}</v-list-item-title>
              </v-list-item-content>
            </template>

            <v-list>
              <v-list-group
                v-for="competition in category.competitions"
                :key="competition.id"
                no-action
                class="competition"
              >
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title>{{ competition.name }}</v-list-item-title>
                  </v-list-item-content>
                </template>

                <v-list-item
                  v-for="event in competition.events"
                  :key="event.id"
                  class="event"
                  @click="getMarkets(event)"
                >
                  <v-list-item-content>
                    <v-list-item-title>{{ event.name }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

              </v-list-group>
            </v-list>
          </v-list-group>
        </v-list>
      </v-list-group>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
  export default {
    data: () => ({
      runGetCategories: true
    }),
    computed: {
      ...mapState(['sportCategories']),
      ...mapGetters(['getSportTypes', 'getSportCategories'])
    },
    methods: {
      ...mapActions(['fetchSportMarkets', 'fetchSportCategories']),
      getMarkets(event) {
        this.fetchSportMarkets({ event: event})
      },
      getCategories(sportTypeId) {
        if (this.runGetCategories) {
          this.fetchSportCategories({ sportTypeId: sportTypeId })
        }
        this.runGetCategories = !this.runGetCategories
      }
    }
  }
</script>

<style>
  .event {
    padding-left: 25px !important;
  }

  .competition {
    padding-left: 15px !important;
  }

  .category {
    padding-left: 10px !important;
  }

  .loadingCategory {
    padding-left: 30px !important;
  }
</style>